export default __webpack_public_path__ + "static/media/sounds/rct_accuracy_practice_incorrect_2.mp3";